'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function BlogCardSkeleton() {
  return (
    <div
      className={cn('animate-pulse', 'col-span-1 flex w-full flex-col items-start justify-start')}
    >
      <div className="h-[230px] w-full bg-neutral-100 sm:h-[245px] md:h-[260px] lg:h-[275px] xl:h-[288px] rounded-[16px]" />
      <div className="flex w-full flex-col items-start justify-start gap-4 pt-3 sm:pt-4">
        <div className="h-[100px] w-full bg-neutral-100 rounded-[16px]" />
      </div>
    </div>
  );
}
